<template>
  <div>
    <TeacherNavbar />
    <router-view />
    <TeacherFooter/>
  </div>
</template>

<script>
import TeacherNavbar from './components/TeacherNavbar.vue';
import TeacherFooter from "@/components/TeacherFooter.vue";


export default {
  name: 'App',
  components: {
    TeacherFooter,
    TeacherNavbar,

  },
};
</script>

<style>
/* Глобальные стили */
body {
  margin: 0;
  font-family: Arial, sans-serif;
  background: rgba(224, 223, 223, 0.32); /* Белый фон */
  background-size: cover;
  color: #333;
}
</style>